export default "__VITE_ASSET__BeB8V06M__"